/*
 * Welcome to your app's main JavaScript file!
 *
 * We recommend including the built version of this JavaScript file
 * (and its CSS file) in your base layout (base.html.twig).
 */

// any CSS you import will output into a single css file (app.css in this case)
import './styles/app.css';
require('../node_modules/bootstrap/dist/js/bootstrap.bundle')


document.querySelectorAll('form').forEach(form => {
    form.addEventListener('submit', (e) => {
        const button = form.querySelector('button[type="submit"]');
        if (button) {
            button.classList.add('loader');
        }
    });
});